export type ModbusCommunicationStatus =
  | "never"
  | "ok"
  | "timeout"
  | "bad-frame"
  | "exception";

export type ModbusFailureDiagnostic = Exclude<ModbusCommunicationStatus, "ok">;

export interface ModbusDiagnosticPresentation {
  label: string;
  tone: "danger" | "warn" | "ok";
}

/** Interpreta `s` apenas no modo MB; nos demais modos ele continua binario/NE43. */
export function resolveModbusStatus(
  mode: unknown,
  status: unknown,
): ModbusCommunicationStatus | null {
  if (String(mode ?? "").trim().toUpperCase() !== "MB") return null;
  if (
    status === null ||
    status === undefined ||
    typeof status === "boolean" ||
    (typeof status === "string" && status.trim() === "")
  ) {
    return null;
  }

  const numericStatus = typeof status === "number" ? status : Number(status);
  if (!Number.isInteger(numericStatus)) return null;

  switch (numericStatus) {
    case 0:
      return "never";
    case 1:
      return "ok";
    case 2:
      return "timeout";
    case 3:
      return "bad-frame";
    case 4:
      return "exception";
    default:
      return null;
  }
}

export function resolveModbusDiagnostic(
  mode: unknown,
  status: unknown,
): ModbusFailureDiagnostic | null {
  const resolved = resolveModbusStatus(mode, status);
  return resolved && resolved !== "ok" ? resolved : null;
}

export function describeModbusStatus(
  status: ModbusCommunicationStatus,
): ModbusDiagnosticPresentation {
  switch (status) {
    case "never":
      return { label: "AGUARDANDO MODBUS", tone: "warn" };
    case "ok":
      return { label: "MODBUS OK", tone: "ok" };
    case "timeout":
      return { label: "TIMEOUT MODBUS", tone: "danger" };
    case "bad-frame":
      return { label: "QUADRO MODBUS INVALIDO", tone: "danger" };
    case "exception":
      return { label: "EXCECAO MODBUS", tone: "danger" };
  }
}
